import { render, staticRenderFns } from "./GalleryPagination.vue?vue&type=template&id=2133b733&scoped=true&"
import script from "./GalleryPagination.vue?vue&type=script&lang=js&"
export * from "./GalleryPagination.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPagination.vue?vue&type=style&index=0&id=2133b733&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2133b733",
  null
  
)

export default component.exports